module.exports = __webpack_public_path__ + "static/2-b6dc51cf43edda78f3002af313d5740e.jpg";